import { ChevronDown } from 'lucide-react';

export const ScrollDownIndicator = () => {
  const handleClick = () => {
    const aboutSection = document.getElementById('about') 
      || document.querySelector('[class*="HomeAboutSection"]')
      || document.querySelector('section:nth-of-type(2)');
    
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollBy({ top: window.innerHeight * 0.6, behavior: 'smooth' });
    }
  };

  return (
    <div className="flex md:hidden justify-center py-2 -mt-10">
      <button
        onClick={handleClick}
        aria-label="Scroll down"
        className="group flex flex-col items-center gap-0.5 text-muted-foreground/50 hover:text-muted-foreground/70 transition-colors duration-300"
      >
        <span className="text-[11px] tracking-[0.2em] uppercase font-light">Scroll</span>
        <div className="relative h-8 flex flex-col items-center justify-start overflow-hidden">
          <ChevronDown 
            size={18} 
            strokeWidth={1.5}
            className="animate-[scrollArrow_2s_ease-in-out_infinite] opacity-60"
          />
        </div>
      </button>
    </div>
  );
};
